import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { NavLink } from 'react-router-dom';
import PostingsApi from '../../../API/shipment/postings-api';
import RealizationApi from '../../../API/shipment/realization-api';
import close from '../../../assets/media/icons/close.svg';
import { Column, NavTabs, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { DateInput, InputLabel, Select } from '../../../components/Basic/Inputs';
import { HeaderTitle, Table, TableCell, TableHeader, TableLine } from '../../../components/Basic/Table';
import { H1 } from '../../../components/Basic/WrapsStyle';
import {
  REALIZATION_STATUS,
  REPORT_TYPE,
  STATUS_COLORS,
  TO_REALIZATION,
  TYPE_BUTTONS
} from '../../../constans';
import { getDate, numberWithSpaces } from '../../../utils';
import CreateRealizationPopUp from './CreateRealizationPopUp';
import DeleteRealizationPopUp from './DeleteRealizationPopUp';
import styles from './styles.module.scss';

const width = ['40px', '140px', '150px', '200px', '250px'];

const FILTER = {
  0: '',
  1: 'ozon',
  2: 'wb',
  3: 'yandex',
  4: 'kuper',
  5: 'avito',
};

const STATUSES = ['Не выбран', 'Не начата', 'Завершена', 'В работе'];

const MARKET_NAME = {
  ozon: 'Ozon',
  yandex: 'Yandex',
  wb: 'Wb',
  megamarket: 'Megamarket',
  avito: 'Avito',
  Ozon: 'Ozon',
  Yandex: 'Yandex',
  Wb: 'Wb',
  Sber: 'Megamarket',
  kuper: 'Купер',
};

function RealizationsPage() {
  const [create, setCreate] = useState(false);
  const [popUpDelete, setDeletePopUp] = useState({ show: false, realization: {} });
  const [reportType, setReportType] = useState('Подотчетный');

  const [count, setCount] = useState([0, 0, 0, 0, 0]);
  const [tab, setTab] = useState(0);
  const [show, setShow] = useState(50);

  const [realizations, setRealizations] = useState([]);
  const [realizationsSelect, setRealizationsSelect] = useState({});
  const user = useSelector((store) => store.user);
  const [date, setDate] = useState(null);
  const [status, changeStatus] = useState('Не выбран');

  const onClickCreate = () => {
    setCreate(true);
  };

  const changeRealizationSelect = (number) => {
    if (realizationsSelect[number]) {
      const s = realizationsSelect;
      delete s[number];
      setRealizationsSelect({ ...s });
    } else {
      setRealizationsSelect({ ...realizationsSelect, [number]: true });
    }
    //setPostingsPrint({ ...postingsPrint, [order_number]: !postingsPrint[order_number] });
  };

  const openManyRealizations = () => { };
  const loadRealizations = () => {
    const MAP_TYPE = {
      Ежедневный: 'system',
      Подотчетный: 'report',
    };

    let MAP_STATUS = {
      'Не начата': 'not_started',
      Завершена: 'ended',
      'В работе': 'started',
      'Не выбран': undefined,
    };

    RealizationApi.getRealizations({
      data: {
        status: MAP_STATUS[status],
        market: FILTER[tab],
        limit: parseInt(show),
        dateRealization: date,
        realizationType: reportType === 'Не выбран' ? undefined : MAP_TYPE[reportType],
      }
    }).then((r) => setRealizations(r.realizations));
  };

  const onChangeTab = (n) => {
    setTab(n);
  };

  const onCloseDelete = () => {
    setDeletePopUp({ show: false, realization: {} });
    loadRealizations();
  };

  useEffect(() => {
    loadRealizations();
  }, [tab, show, date, reportType, status]);

  const realizations_ids = Object.keys(realizationsSelect);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <H1>Реализации</H1>

        <WhiteBlock className={styles.search_block}>
          <Row className={styles.navigate_table}>
            <NavTabs
              open_tab={tab}
              tabs={['Все реализации', 'Ozon', 'Wildberries', 'ЯндексМаркет', 'Купер', 'Avito']}
              num={count}
              style_tab={styles.style_tab}
              onChange={onChangeTab}
            />
          </Row>
          <Row spaceBetween={true} style={{ marginTop: '25px' }}>
            <Row style={{ height: '40px' }}>
              <div>
                <Select
                  label="Показать на странице"
                  select={show}
                  list={['10', '20', '50', '100', '150', '200', '500', '1000']}
                  onSelect={(v) => setShow(v)}
                  width="150px"
                  style={{ marginRight: '15px' }}
                />
              </div>

              <Column style={{ marginRight: '15px' }}>
                <InputLabel>Дата реализации</InputLabel>
                <Row style={{ position: 'relative', width: '150px' }}>
                  <DateInput value={date} className={styles.calendar} onChange={(v) => setDate(v)} />
                  <Button className={styles.close_button} onClick={() => setDate(null)}>
                    <img src={close} style={{ width: '15px' }} />
                  </Button>
                </Row>
              </Column>
              <div>
                <Select
                  label="Статус реализации"
                  select={status}
                  list={STATUSES}
                  width="200px"
                  onSelect={(v) => changeStatus(v)}
                  style={{ marginRight: '15px' }}
                />
              </div>
              <div>
                <Select
                  list={['Не выбран', 'Ежедневный', 'Подотчетный']}
                  select={reportType}
                  label="Тип реализации"
                  onSelect={(v) => setReportType(v)}
                  width={'150px'}
                  style={{ marginRight: '15px' }}
                />
              </div>
              {isOwner && (
                <Button type={TYPE_BUTTONS.GREEN} onClick={onClickCreate}>
                  Создать реализацию
                </Button>
              )}
              {realizations_ids.length > 1 && (
                <a href={TO_REALIZATION(realizations_ids.join('&'))} target={'_blank'} style={{ marginLeft: '10px' }}>
                  <Button type={TYPE_BUTTONS.BLUE} onClick={openManyRealizations}>
                    Открыть совместную реализацию
                  </Button>
                </a>
              )}
              <Button
                type={TYPE_BUTTONS.GREEN}
                onClick={() => PostingsApi.updatePostingsStatus({})}
                style={{ marginLeft: '15px' }}
                disabled={tab === 0 || tab === 5}
              >
                Обновить статусы
              </Button>
            </Row>
          </Row>
        </WhiteBlock>
        <Table>
          <TableHeader whiteHeader>
            <HeaderTitle width={width[0]} />
            <HeaderTitle width={width[0]}>Id</HeaderTitle>
            <HeaderTitle width={width[1]}>Площадка</HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Дата реализации
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Количество заказов
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Статус
            </HeaderTitle>
            <HeaderTitle width={width[2]} centerText>
              Тип
            </HeaderTitle>
            <HeaderTitle width={width[4]} centerText>
              Статистика
            </HeaderTitle>
            <HeaderTitle width={width[3]} centerText>
              Создатель
            </HeaderTitle>
          </TableHeader>
          {(realizations || []).map((realization) => {
            return (
              <TableLine key={realization.id}>
                <TableCell width={width[0]}>
                  <CheckButton
                    checked={realizationsSelect[realization.id]}
                    onSelect={() => changeRealizationSelect(realization.id)}
                  />
                </TableCell>
                <TableCell width={width[0]}>{realization.id}</TableCell>
                <TableCell width={width[1]}>
                  <NavLink to={TO_REALIZATION(realization.id)} className={styles.line_table_link}>
                    {MARKET_NAME[realization.market]} {realization.is_express && 'Express'}
                  </NavLink>
                </TableCell>
                <TableCell width={width[2]} center>
                  {getDate(realization.date_realization)}
                </TableCell>
                <TableCell width={width[2]} center>
                  {numberWithSpaces(realization.count) || 0}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[realization.status]}` }} center>
                  {REALIZATION_STATUS[realization.status]}
                </TableCell>
                <TableCell width={width[2]} style={{ color: `${STATUS_COLORS[realization.state]}` }} center>
                  {REPORT_TYPE[realization.type]}
                </TableCell>
                <TableCell width={width[4]} center>
                  {`${realization.count} /${realization.statistic?.op3 || 0} / ${realization.statistic?.op2 || 0} / ${realization.statistic?.op1 || 0
                    } / ${realization.statistic?.op0 || 0} / ${realization.statistic?.bad_purchase || 0}/ ${realization.statistic?.not_enough || 0
                    } / ${realization.statistic?.not_ip || 0} / ${realization.statistic?.[''] || 0} `}
                </TableCell>
                <TableCell width={width[3]} center>
                  {realization.creator}
                </TableCell>
              </TableLine>
            );
          })}
        </Table>
      </Content>
      {create && (
        <CreateRealizationPopUp
          close={() => {
            setCreate(false);
            loadRealizations();
          }}
        />
      )}
      {popUpDelete.show && <DeleteRealizationPopUp shipment={popUpDelete.realization} close={onCloseDelete} />}
    </>
  );
}

export default RealizationsPage;
